import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React from "react";
import { usePromise } from "../../../Utils/usePromise";
import axios from "axios";
import Spinner from "reactstrap/es/Spinner";
import { parseApiError } from "@yooink/youtils/es/ParseApiError";
import { Alert } from "reactstrap";
import Button from "reactstrap/es/Button";
export function UsersRegistrationsChart({ from, to }) {
    const { isLoading, isError, data, errData, run } = usePromise(async () => {
        return axios.get('/api/v2/analytics/charts/usersRegistrations', { params: { from, to } }).then(res => res.data.items);
    }, [from.getTime(), to.getTime()]);
    if (isLoading)
        return _jsx(Spinner, {});
    if (isError)
        return (_jsxs(Alert, Object.assign({ color: 'danger' }, { children: [_jsx("pre", { children: parseApiError(errData) }), _jsx(Button, Object.assign({ onClick: run }, { children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C" }))] })));
    return (_jsx(ResponsiveContainer, Object.assign({ width: "100%", height: 300 }, { children: _jsxs(LineChart, Object.assign({ width: 1050, height: 300, data: data, margin: {
                top: 10,
                right: 0,
                left: -42,
                bottom: 0
            } }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3" }), _jsx(XAxis, { dataKey: "label" }), _jsx(YAxis, {}), _jsx(Tooltip, { isAnimationActive: false }), _jsx(Line, { type: "monotone", name: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0439", dataKey: "value", stroke: "#58623E", activeDot: { r: 8 } })] })) })));
}
export function OrdersCountChart({ from, to, promocode }) {
    const { isLoading, isError, data, errData, run } = usePromise(async () => {
        let url = promocode ? `/api/v2/analytics/charts/ordersCount/promocodes/${promocode}` : '/api/v2/analytics/charts/ordersCount';
        return axios.get(url, { params: { from, to } }).then(res => res.data.items);
    }, [from.getTime(), to.getTime()]);
    if (isLoading)
        return _jsx(Spinner, {});
    if (isError)
        return (_jsxs(Alert, Object.assign({ color: 'danger' }, { children: [_jsx("pre", { children: parseApiError(errData) }), _jsx(Button, Object.assign({ onClick: run }, { children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C" }))] })));
    return (_jsx(ResponsiveContainer, Object.assign({ width: "100%", height: 300 }, { children: _jsxs(LineChart, Object.assign({ width: 1050, height: 300, data: data, margin: {
                top: 10,
                right: 0,
                left: -42,
                bottom: 0
            } }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3" }), _jsx(XAxis, { dataKey: "label" }), _jsx(YAxis, {}), _jsx(Tooltip, { isAnimationActive: false }), _jsx(Line, { type: "monotone", name: "\u0417\u0430\u043A\u0430\u0437\u044B", dataKey: "value", stroke: "#58623E", activeDot: { r: 8 } })] })) })));
}
